import { FacebookRounded, Twitter, LinkedIn, Instagram, YouTube } from "@mui/icons-material";
import { Avatar } from '@mui/material';
import "./Ui-footer.scss";

const SocialIconsLinks = () => {

    const socialIcons = [
        {
            icon: <FacebookRounded className="footer-icons" sx={{ fontSize: '18px', color: 'white' }} />,
            path: 'https://www.facebook.com/people/Pay-Penalty-Charge-Notice/100070145893531/'
        },
        {
            icon: <Twitter className="footer-icons" sx={{ fontSize: '18px', color: 'white' }} />,
            path: 'https://twitter.com/PPCN_01'
        },
        {
            icon: <LinkedIn className="footer-icons" sx={{ fontSize: '18px', color: 'white' }} />,
            path: 'https://www.linkedin.com/authwall?trk=bf&trkInfo=AQG3H2Bdvw21IgAAAYQSTm8opymayFWsgX-qtXSLbI0dHKrQyF7Ho40fg5Yu3uAKW6mRw7co6xm0yI8cPQQSGRxoKWbLl1PrSZh-c1jjSPkm0A5wwTvM5aPjzajUwJv-5teXqPg=&original_referer=&sessionRedirect=https%3A%2F%2Fwww.linkedin.com%2Fcompany%2Fpaypenaltychargenotice%3Foriginal_referer%3Dhttps%253A%252F%252Fwww.ppcn.co.uk%252F'
        },
        {
            icon: <Instagram className="footer-icons" sx={{ fontSize: '18px', color: 'white' }} />,
            path: 'https://www.instagram.com/pay_penaltychargenotice/'
        },
        {
            icon: <YouTube className="footer-icons" sx={{ fontSize: '18px', color: 'white' }} />,
            path: 'https://www.youtube.com/channel/UCtVRZj3-PBar_qo4uKrcVMQ'
        },
    ]

    return (
        <>
            {socialIcons.map((item, index) => {
                return (
                    <a href={item.path} target='_blank' className="social" key={index}>
                        <Avatar className="links cursor-pointer">
                            {item.icon}
                        </Avatar>
                    </a>
                )
            })}
        </>
    )
}

export default SocialIconsLinks